import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalWithActions from '../../ModalWithActions';
import ViewPicker from './ViewPicker';

const SchemaDocumentationModal = ({
  onSenderModalHide,
  modalShow,
  schema,
  exampleSchema,
}) => {
  const { t } = useTranslation();

  return (
    <ModalWithActions
      show={modalShow}
      modalTitle={t('management_menu.actuator_library.schema_documentation')}
      btActionText={t('modal.close')}
      cancelActionVisible={false}
      action={onSenderModalHide}
      onHide={onSenderModalHide}
      width="100%"
      inputComponent={
        <ViewPicker schema={schema} exampleSchema={exampleSchema} />
      }
    />
  );
};

SchemaDocumentationModal.propTypes = {
  onSenderModalHide: PropTypes.func.isRequired,
  modalShow: PropTypes.bool.isRequired,
  schema: PropTypes.object,
  exampleSchema: PropTypes.object,
};

export default SchemaDocumentationModal;
